export default "__VITE_ASSET__YTi1Pm13w360ttBm$77J3w__"